import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme<{ isLegacySplitLayoutRoute?: boolean }> = ({ theme, isLegacySplitLayoutRoute }) => ({
    display: 'flex',
    flexDirection: 'column',

    position: 'relative',

    width: '100%',

    backgroundColor: isLegacySplitLayoutRoute ? theme.colors.white : 'transparent',

    min1024: {
        flexDirection: 'row',

        overflow: 'auto',
        flexShrink: 0,

        width: isLegacySplitLayoutRoute ? `calc(50% + ${theme.widths.menu / 2}px)` : '100%',

        extend: {
            condition: isLegacySplitLayoutRoute,
            style: {
                borderRightWidth: 1,
                borderRightStyle: 'solid',
                borderRightColor: theme.colors.foregroundsSeparator,
            },
        },
    },
});
